import { render, staticRenderFns } from "./PagePreviewItem.vue?vue&type=template&id=96acd072"
import script from "./PagePreviewItem.vue?vue&type=script&lang=js"
export * from "./PagePreviewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports